import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

import { ICategories } from '../models/categoriesresponse.model';
import { CoreService } from '../../shared/services/core.service';
import { ECategoriesActions, GetCategories, GetCategoriesSuccess } from '../actions/category.actions';
import { CategoryService } from 'src/app/shared/services/category.service';

@Injectable()
export class CategoriesEffects {
  
  getCategories$ = createEffect(() => this._actions$.pipe(
    ofType<GetCategories>(ECategoriesActions.GetCategories),
    switchMap((action) => this.categoryService.getCategories(action.payload)),
    switchMap((Categories:ICategories) => {
      return of(new GetCategoriesSuccess(Categories));
    })
  ));
  
  constructor(
    private categoryService: CategoryService,
    private _actions$: Actions) {
    }
}
